<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable max-len -->
<template>
  <div class="giftcard text-center">
    <div v-if="!encoded || !responseValid">
      <h3>{{ $t("giftcardLanding.invalidParams") }}</h3>
    </div>
    <div v-if="responseValid">
      <h1>{{ $t("giftcardLanding.title") }}</h1>

      <p class="description">
        {{ $t("giftcardLanding.subtitle.intro") }}
        <span class="font-bold"> ${{ giftcard.value }} </span>
        {{ $t("giftcardLanding.subtitle.finish") }}
      </p>

      <p class="discount mb-2">
        {{ $t("giftcardLanding.subtitle.discount") }}
      </p>

      <div
        ref="capture"
        class="w-full flex-container">
        <p
          class="coupon absolute position-code"
          :style="{ color: giftcard.color }"
        >
          {{ giftcard.code }}
        </p>

        <img
          v-if="giftcard.logo"
          :src="giftcard.logo"
          class="absolute logo-giftcard"
        >

        <p class="absolute position-value coupon">
          <span :style="{ color: giftcard.color }">
            $ {{ giftcard.value }}
          </span>
        </p>

        <p
          v-if="giftcard.endDate"
          class="absolute position-enddate coupon">
          {{ $t("giftcardLanding.subtitle.expiration") }}
          <span
            class="font-bold"
            :style="{ color: giftcard.color }">
            {{ giftcard.endDate }}
          </span>
        </p>

        <svg
          width="500"
          height="286"
          viewBox="0 0 500 286"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M457.048 0H42.9516C19.2301 0 0 19.2301 0 42.9516V242.114C0 265.836 19.2301 285.066 42.9516 285.066H457.048C480.77 285.066 500 265.836 500 242.114V42.9516C500 19.2301 480.77 0 457.048 0Z"
            :style="{ fill: giftcard.bg }"
          />
          <path
            d="M499.748 191.221H0.252274V216.448H499.748V191.221Z"
            fill="#59646A"
          />
          <path
            d="M499.748 216.448H0.252274V241.675H499.748V216.448Z"
            fill="#4E595F"
          />
          <path
            d="M187.967 214.99H195.863V228.239C193.623 229.193 191.246 229.672 188.724 229.672C185.721 229.672 183.411 228.532 181.791 226.246C180.172 223.961 179.364 220.671 179.364 216.372C179.364 212.074 180.293 208.981 182.144 206.64C184.001 204.299 186.594 203.123 189.929 203.123C191.993 203.123 193.956 203.653 195.833 204.712L194.314 208.633C192.856 207.785 191.488 207.361 190.217 207.361C188.391 207.361 186.948 208.179 185.878 209.808C184.813 211.438 184.279 213.663 184.279 216.478C184.279 219.294 184.662 221.594 185.434 223.138C186.206 224.682 187.326 225.454 188.799 225.454C189.576 225.454 190.363 225.353 191.166 225.151V219.233H187.967V214.995V214.99Z"
            fill="white"
          />
          <path
            d="M200.671 229.319V203.486H205.192V229.319H200.671Z"
            fill="white"
          />
          <path
            d="M215.424 229.319H210.656V203.486H222.23V207.639H215.429V214.813H221.771V218.966H215.429V229.319H215.424Z"
            fill="white"
          />
          <path
            d="M233.391 229.319H228.602V207.709H223.653V203.486H238.335V207.709H233.391V229.319Z"
            fill="white"
          />
          <path
            d="M258.602 207.321C257.225 207.321 256.135 208.128 255.343 209.743C254.546 211.357 254.152 213.602 254.152 216.473C254.152 222.457 255.711 225.449 258.835 225.449C260.202 225.449 261.63 225.015 263.128 224.142V228.416C261.867 229.253 260.252 229.672 258.29 229.672C255.378 229.672 253.143 228.517 251.584 226.201C250.025 223.885 249.243 220.631 249.243 216.438C249.243 212.245 250.045 208.976 251.655 206.635C253.264 204.294 255.5 203.118 258.36 203.118C259.304 203.118 260.207 203.249 261.075 203.507C261.942 203.764 262.866 204.218 263.855 204.869L262.265 208.774C261.736 208.411 261.171 208.078 260.57 207.775C259.97 207.472 259.314 207.326 258.607 207.326L258.602 207.321Z"
            fill="white"
          />
          <path
            d="M279.011 229.319L277.528 222.8H270.797L269.314 229.319H264.506L270.903 203.38H277.422L283.835 229.319H279.011ZM276.625 218.542L275.247 212.533C275.166 212.17 274.98 211.251 274.692 209.783C274.405 208.315 274.228 207.336 274.173 206.842C274.021 207.856 273.824 208.971 273.587 210.192C273.35 211.413 272.74 214.193 271.751 218.542H276.625Z"
            fill="white"
          />
          <path
            d="M290.918 219.263V229.319H286.11V203.486H292.402C295.061 203.486 297.028 204.117 298.295 205.378C299.561 206.64 300.192 208.562 300.192 211.155C300.192 214.42 299.092 216.695 296.887 217.992L301.852 229.319H296.71L292.629 219.263H290.913H290.918ZM290.918 215.131H292.154C293.285 215.131 294.097 214.808 294.591 214.167C295.086 213.527 295.333 212.568 295.333 211.297C295.333 210.025 295.071 209.036 294.546 208.476C294.021 207.916 293.214 207.639 292.119 207.639H290.918V215.131Z"
            fill="white"
          />
          <path
            d="M320.636 216.155C320.636 220.419 319.768 223.678 318.027 225.933C316.292 228.189 313.789 229.319 310.53 229.319H304.203V203.486H311.11C314.112 203.486 316.453 204.596 318.123 206.816C319.793 209.036 320.631 212.149 320.631 216.155H320.636ZM315.706 216.297C315.706 210.525 314.117 207.639 310.938 207.639H309.011V225.111H310.565C312.321 225.111 313.618 224.379 314.45 222.911C315.288 221.443 315.706 219.238 315.706 216.297Z"
            fill="white"
          />
          <mask
            id="mask0_1_116"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="179"
            y="216"
            width="142"
            height="15"
          >
            <path
              d="M320.636 216.448H179.364V230.575H320.636V216.448Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1_116)">
            <g opacity="0.1">
              <path
                d="M187.967 214.99H195.863V228.239C193.623 229.193 191.246 229.672 188.724 229.672C185.721 229.672 183.411 228.532 181.791 226.246C180.172 223.961 179.364 220.671 179.364 216.372C179.364 212.074 180.293 208.981 182.144 206.64C184.001 204.299 186.594 203.123 189.929 203.123C191.993 203.123 193.956 203.653 195.833 204.712L194.314 208.633C192.856 207.785 191.488 207.361 190.217 207.361C188.391 207.361 186.948 208.179 185.878 209.808C184.813 211.438 184.279 213.663 184.279 216.478C184.279 219.294 184.662 221.594 185.434 223.138C186.206 224.682 187.326 225.454 188.799 225.454C189.576 225.454 190.363 225.353 191.166 225.151V219.233H187.967V214.995V214.99Z"
                fill="black"
              />
              <path
                d="M200.671 229.319V203.486H205.192V229.319H200.671Z"
                fill="black"
              />
              <path
                d="M215.424 229.319H210.656V203.486H222.23V207.639H215.429V214.813H221.771V218.966H215.429V229.319H215.424Z"
                fill="black"
              />
              <path
                d="M233.391 229.319H228.602V207.709H223.653V203.486H238.335V207.709H233.391V229.319Z"
                fill="black"
              />
              <path
                d="M258.602 207.321C257.225 207.321 256.135 208.128 255.343 209.743C254.546 211.357 254.152 213.602 254.152 216.473C254.152 222.457 255.711 225.449 258.835 225.449C260.202 225.449 261.63 225.015 263.128 224.142V228.416C261.867 229.253 260.252 229.672 258.29 229.672C255.378 229.672 253.143 228.517 251.584 226.201C250.025 223.885 249.243 220.631 249.243 216.438C249.243 212.245 250.045 208.976 251.655 206.635C253.264 204.294 255.5 203.118 258.36 203.118C259.304 203.118 260.207 203.249 261.075 203.507C261.942 203.764 262.866 204.218 263.855 204.869L262.265 208.774C261.736 208.411 261.171 208.078 260.57 207.775C259.97 207.472 259.314 207.326 258.607 207.326L258.602 207.321Z"
                fill="black"
              />
              <path
                d="M279.011 229.319L277.528 222.8H270.797L269.314 229.319H264.506L270.903 203.38H277.422L283.835 229.319H279.011ZM276.625 218.542L275.247 212.533C275.166 212.17 274.98 211.251 274.692 209.783C274.405 208.315 274.228 207.336 274.173 206.842C274.021 207.856 273.824 208.971 273.587 210.192C273.35 211.413 272.74 214.193 271.751 218.542H276.625Z"
                fill="black"
              />
              <path
                d="M290.918 219.263V229.319H286.11V203.486H292.402C295.061 203.486 297.028 204.117 298.295 205.378C299.561 206.64 300.192 208.562 300.192 211.155C300.192 214.42 299.092 216.695 296.887 217.992L301.852 229.319H296.71L292.629 219.263H290.913H290.918ZM290.918 215.131H292.154C293.285 215.131 294.097 214.808 294.591 214.167C295.086 213.527 295.333 212.568 295.333 211.297C295.333 210.025 295.071 209.036 294.546 208.476C294.021 207.916 293.214 207.639 292.119 207.639H290.918V215.131Z"
                fill="black"
              />
              <path
                d="M320.636 216.155C320.636 220.419 319.768 223.678 318.027 225.933C316.292 228.189 313.789 229.319 310.53 229.319H304.203V203.486H311.11C314.112 203.486 316.453 204.596 318.123 206.816C319.793 209.036 320.631 212.149 320.631 216.155H320.636ZM315.706 216.297C315.706 210.525 314.117 207.639 310.938 207.639H309.011V225.111H310.565C312.321 225.111 313.618 224.379 314.45 222.911C315.288 221.443 315.706 219.238 315.706 216.297Z"
                fill="black"
              />
            </g>
          </g>
        </svg>
      </div>

      <div class="url">
        <a
          target="_blank"
          class="btn primary"
          :href="giftcard.url">
          {{ $t("giftcardLanding.button") }}
        </a>
      </div>
    </div>

    <hr v-if="responseValid">

    <div v-if="responseValid">
      <div class="share">
        <p>
          {{ $t("giftcardLanding.share.title") }}
        </p>

        <div class="buttons">
          <button
            v-for="app in shareApps"
            :key="app.id"
            :style="[{ backgroundColor: app.color }, app.style]"
            @click="share(app)"
          >
            {{ app.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "md5";

export default {
  data() {
    return {
      encoded: "",
      responseValid: null,
      giftcard: {
        bg: null,
        color: null,
        code: null,
        endDate: null,
        logo: null,
        security: null,
        value: null,
        url: null,
      },
      shareApps: [
        {
          id: "whatsapp",
          name: this.$t("giftcardLanding.share.links.whatsapp.title"),
          href: `${this.$t("giftcardLanding.share.links.whatsapp.href")}%0A${window.location.href}`,
          color: "#32D16B",
        },
        {
          id: "email",
          name: this.$t("giftcardLanding.share.links.email.title"),
          href: `${this.$t("giftcardLanding.share.links.email.href")}%0A${window.location.href}`,
          color: "#e83d80",
        },
      ],
    };
  },
  computed: {
    apps() {
      return this.shareApps.filter((item) => {
        if (item.id === 'native') return navigator.share;
        return true;
      });
    },
  },
  async created() {
    document.title = this.$t("giftcardLanding.pageTitle");
    this.isMobile = this.checkIsMobile();
    if (this.isMobile) {
      const mobile = {
        id: "native",
        name: this.$t("giftcardLanding.share.links.native.title"),
        color: "#FFFFFF",
        style: { border: "2px solid #1CAEEA", color: "#1CAEEA" },
      };
      this.shareApps.push(mobile);
    }
    this.getEncoded();
    await this.getData();
  },
  methods: {
    getEncoded() {
      this.encoded = this.$route.params.encoded;
      if (!this.encoded) return false;
      return true;
    },
    checkIsMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      this.isMobile = /android|iphone|ipad|ipod|opera mini|iemobile|wpdesktop/i.test(userAgent);
    },
    async getData() {
      if (!this.encoded) return false;

      try {
        const decodedString = atob(this.encoded);
        const decodedCode = JSON.parse(decodedString);

        this.giftcard.bg = decodedCode.landingBg;
        this.giftcard.code = decodedCode.code;
        this.giftcard.color = decodedCode.landingColor;
        this.giftcard.endDate = decodedCode.endDate;
        this.giftcard.logo = decodedCode.landingLogo;
        this.giftcard.security = decodedCode.security;
        this.giftcard.value = decodedCode.value;
        this.giftcard.url = decodedCode.urlStore;

        if (!this.isSecure()) {
          this.responseValid = false;
          return false;
        }
        this.giftcard.value = this.formatNumber(decodedCode.value);

        if (this.giftcard.endDate) {
          this.giftcard.endDate = this.formatDate(this.giftcard.endDate);
        }

        this.responseValid = true;
      } catch {
        this.responseValid = false;
      }

      return true;
    },
    formatNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    isSecure() {
      const securityString =
        this.giftcard.value + this.giftcard.code + this.giftcard.url;
      const securityHash = md5(securityString);
      const securityHashSlice = securityHash.slice(-6);

      if (securityHashSlice === this.giftcard.security) return true;
      return false;
    },
    async share(app) {
      if (app.id === "native" && this.isMobile) {
        return navigator.share({
          title: app.name,
          url: window.location.href,
        });
      }
      return window.open(app.href, "_blank");
    },
  },
};

</script>
